import React from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import { t } from 'translation'
import { ANXIETY, AWAKENING, SLEEP, PAIN } from 'utils/constants'

const HistoryModalListItem = ({
  artist,
  genreName,
  title,
  launchSongFromHistory,
  time,
  indicationType,
  painLevelAfter,
  painLevelBefore,
}) => (
  <li className="popup_list_item">
    <button className="popup_list_item_btn" onClick={launchSongFromHistory}>
      <div className="popup_list_item_head">
        <div className="popup_list_item_genre">{genreName}</div>
        <div className="popup_list_item_info popup_list_item_song">{title}</div>
        <div className="popup_list_item_info popup_list_item_artist">{artist}</div>
        <div className="popup_list_item_rating_info">
          <span className="popup_list_item_rating_indication">
            {t(`history.${indicationType.toUpperCase()}`)}
          </span>
          {(indicationType === ANXIETY || indicationType === PAIN) && (
            <span className="popup_list_item_rating_pain">
              {t('history.BEFORE')} {painLevelBefore}
            </span>
          )}
          <span className="popup_list_item_rating_pain">
            {t('history.AFTER')} {painLevelAfter}
          </span>
        </div>
        <div className="popup_list_item_date">{format(new Date(time), 'd/M/yy')}</div>
      </div>
    </button>
  </li>
)

export default HistoryModalListItem

HistoryModalListItem.propTypes = {
  artist: PropTypes.string.isRequired,
  genreName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  launchSongFromHistory: PropTypes.func.isRequired,
  time: PropTypes.string.isRequired,
  indicationType: PropTypes.oneOf([ANXIETY, AWAKENING, PAIN, SLEEP]),
  painLevelAfter: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
  painLevelBefore: PropTypes.oneOf([null, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
}
